export const INDIVIDUAL_MAIL_THREAD_RECEIVERS_MAX_COUNT = 1;
